import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { ALL_OPTION } from '@/common/constants';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'GET_ORGANIZATION_TITLE';
interface Params {
  employerIds?: string[];
  employerId?: string;
}
const useGetOrganizationsTitleQuery = ({ employerId, employerIds }: Params) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, employerIds?.join(','), employerId],
    () =>
      api.get(API_URL.ORGANIZATIONS_NAMES, {
        params: {
          ids: employerIds?.length ? employerIds?.join(',') : employerId,
        },
      }),
    {
      enabled: !!employerIds?.length || !!employerId,
    }
  );

  const title = useMemo(() => {
    const list = data?.data || [];
    if (list && list.length) {
      return list?.map((item) => item.name)?.join(',');
    }
    return ALL_OPTION.title;
  }, [data]);
  return {
    data,
    title,
    isLoading,
  };
};

export default useGetOrganizationsTitleQuery;
